import { Routes as ReactRouterRoutes, Route } from 'react-router-dom'
import { ContactNumbers, AddNumber, Success, VehicleData } from '~containers'
import { Layout } from '~components'
import { useAnalytics } from '~hooks'

function Routes() {
  useAnalytics()

  return (
    <ReactRouterRoutes>
      <Route path="" element={<Layout />}>
        <Route path="numeros-contato" element={<ContactNumbers />} />
        <Route path="dados-veiculo" element={<VehicleData />} />
        <Route path="adicionar-celular" element={<AddNumber />} />
        <Route path="numero-sucesso" element={<Success />} />
      </Route>
    </ReactRouterRoutes>
  )
}

export default Routes
